export default __webpack_public_path__ + "static/media/nouman-ijaz.378c1e29.png";